import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    divider: {
      flexGrow: 1,
    },
    date: {
      marginLeft: theme.spacing(),
      marginRight: theme.spacing(),
    },
  }
})
